import { addClickOutsideListener } from "./helpers/dialogHelpers";

const donateDialog = <HTMLDialogElement>document.querySelector("#DonateDialog");
const openDonateDialogButtons = <NodeListOf<HTMLDivElement>>document.querySelectorAll(".open-donation");

if (donateDialog && openDonateDialogButtons) {
    const close = <HTMLButtonElement>donateDialog.querySelector(".close-button");

    openDonateDialogButtons.forEach((b) => {
        b.addEventListener("click", () => {
            donateDialog.showModal();
        });
    });

    close.addEventListener("click", () => {
        donateDialog.close();
    });

    addClickOutsideListener(donateDialog);
}
